module.exports = __webpack_public_path__ + "img/18.c43e21b1.jpg";